import type { Lookups } from "../../types";
import type { FilterModule } from "../index";
import { getCount } from "../itSpend/chips";
import { defaultItSpendSlice, type ItSpendSlice } from "../itSpend/slice";
import { AISpendFilter } from "./AISpendFilter";
import { getChips } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";

export const aiSpendModule: FilterModule<ItSpendSlice, Lookups> = {
  key: "aiSpend",
  defaultSlice: defaultItSpendSlice,
  Component: AISpendFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
